export default __webpack_public_path__ + "static/media/circles-no-4.5509e77e.mid";